<template>
  <div class="import-dialog-container">
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form class="form" autocomplete="off" @submit.prevent>
        <div v-if="!preview" class="row import">
          <div class="col-md-12">
            <p>Bước 1: Tải file mẫu excel</p>
            <button
              type="button"
              class="btn btn-info btn-sm font-weight-bold"
              @click="downloadExcelExample"
            >
              <i class="flaticon-download mr-1"></i> Tải file mẫu
              <i
                class="el-icon-loading ml-1"
                v-if="is_loading_download_file"
              ></i>
            </button>
          </div>

          <div class="col-md-12 mt-4">
            <p>
              Bước 2: Thiết lập dữ liệu tại file mẫu, tải xuống file định dạng
              .xlsx và upload file đó lên hệ thống
            </p>

            <div class="file-input">
              <input
                v-if="!disable_import"
                type="file"
                accept=".xlsx, .xls, .csv"
                id="file-import-teacher"
                class="file-input__input"
                @change="onFileChange"
              />
              <label
                class="file-input__label"
                for="file-import-teacher"
                :class="{
                  'on-disable-import': disable_import,
                  'disable-import': !disable_import,
                }"
              >
                <span>
                  <i class="flaticon-upload mr-2" style="color: #000000"></i>
                  Upload file
                </span>
              </label>
            </div>

            <div class="result-file mt-2" v-if="files">
              <label class="font-weight-bold text-dark">{{ files.name }}</label>
              <i
                @click="removeFile"
                class="text-danger el-icon-delete cursor-pointer ml-4 font-weight-bold"
              ></i>
            </div>
            <div v-else class="mt-2">
              <p class="text-danger">Chưa có file nào được chọn</p>
            </div>

            <p
              v-if="error_file"
              class="text-danger mt-2"
              style="font-size: 12px"
            >
              {{ error_file }}
            </p>
          </div>
        </div>

        <div v-else class="row preview">
          <div class="col-md-12 mb-2">
            <p class="ml-2 font-weight-bold">Bước 3: Kiểm tra dữ liệu</p>
            <el-alert
              v-if="!pass"
              title="File chứa bản ghi lỗi. Vui lòng kiểm tra danh sách phía dưới, sửa lại file và import lại."
              type="error"
              show-icon
              :closable="false"
              class="mb-3"
            />
          </div>

          <div class="col-md-12 table-responsive">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col" width="60">STT</th>
                  <th scope="col">Mã giảng viên</th>
                  <th scope="col">Mã nhóm giảng viên</th>
                  <th scope="col">Kết quả kiểm tra</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in data_preview" :key="index">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ item.ma_giang_vien }}</td>
                  <td>{{ item.ma_nhom_giang_vien }}</td>
                  <td>
                    <span
                      v-if="!item.errors || !item.errors.length"
                      class="badge badge-success font-weight-bold"
                    >
                      Đạt
                    </span>
                    <span v-else>
                      <span
                        class="text-danger"
                        v-for="(error, key) in item.errors"
                        :key="key"
                      >
                        <span
                          ><i class="el-icon-error mr-1"></i>{{ error }}</span
                        >
                        <br />
                      </span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <hr class="mt-4" />
        <div v-if="preview" class="row d-flex justify-content-end pr-4">
          <button
            type="button"
            class="btn btn-secondary mr-4"
            @click="cancelAction"
          >
            Quay lại
          </button>
          <button
            type="button"
            :disabled="!pass"
            class="btn btn-primary"
            @click="uploadImport"
          >
            Xác nhận
          </button>
        </div>
        <div v-else class="row d-flex justify-content-end pr-4">
          <button
            type="button"
            class="btn btn-secondary mr-4"
            @click="cancelAction"
          >
            Hủy
          </button>
          <button
            type="button"
            :disabled="!files"
            class="btn btn-primary"
            @click="uploadDataTaskImport"
          >
            Tiếp theo
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {
  PREVIEW_IMPORT_GROUP_TEACHER,
  IMPORT_GROUP_TEACHER,
} from "../../../../core/services/store/course/classes.module";
import * as XLSX from "xlsx";

export default {
  name: "DialogImportGroupTeacher",
  data() {
    return {
      preview: false,
      disable_import: false,
      pass: true,
      data_preview: [],
      is_loading_download_file: false,
      files: null,
      error_file: "",
    };
  },
  methods: {
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.files = files[0];
      this.error_file = "";
      this.preview = false;
    },
    removeFile() {
      this.disable_import = false;
      this.files = null;
      this.preview = false;
      this.data_preview = [];
      this.error_file = "";
    },
    cancelAction() {
      if (this.preview) {
        this.preview = false;
        this.disable_import = false;
      } else {
        this.removeFile();
        this.$emit("closeDialog");
      }
    },

    downloadExcelExample() {
      const link = document.createElement("a");
      link.href = "/excel/File mẫu import nhóm giảng viên.xlsx";
      link.download = "File Mẫu Import Nhóm Giảng Viên.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async uploadDataTaskImport() {
      if (!this.files) {
        this.error_file = "Vui lòng chọn file dữ liệu trước!";
        return;
      }

      this.disable_import = true;
      this.error_file = "";

      try {
        const buffer = await this.files.arrayBuffer();

        const workbook = XLSX.read(buffer, {
          type: "array",
        });

        const sheet = workbook.Sheets[workbook.SheetNames[0]];

        const rows = XLSX.utils.sheet_to_json(sheet, {
          defval: "",
        });

        const payload = rows.map((item) => ({
          ma_giang_vien: String(item["Mã giảng viên"] || ""),
          ma_nhom_giang_vien: String(item["Mã nhóm giảng viên"] || ""),
        }));

        const res = await this.$store.dispatch(
          PREVIEW_IMPORT_GROUP_TEACHER,
          payload,
        );

        this.preview = true;
        this.data_preview = res.data || [];

        this.pass = !this.data_preview.some(
          (item) => item.errors && item.errors.length,
        );

        if (this.pass) {
          this.$message.success("Kiểm tra thành công!");
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error(error?.data?.message || "Kiểm tra file thất bại.");
      } finally {
        this.disable_import = false;
      }
    },

    async uploadImport() {
      try {
        const payload = this.data_preview.map((item) => ({
          ma_giang_vien: item.ma_giang_vien,
          ma_nhom_giang_vien: item.ma_nhom_giang_vien,
        }));

        const res = await this.$store.dispatch(IMPORT_GROUP_TEACHER, payload);

        this.$message.success(
          res.message || "Import nhóm giảng viên thành công!",
        );

        this.removeFile();
        this.$emit("getListGroupTeacher");
        this.$emit("closeDialog");
      } catch (error) {
        this.$message.error(
          error?.data?.message || "Có lỗi xảy ra trong quá trình import.",
        );
      }
    },
  },
};
</script>

<style scoped>
.file-input__input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.file-input__label {
  height: 34px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #000000;
  padding: 7px 10px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  transition: all 0.2s ease;
}

.disable-import {
  background-color: #ff9900;
}

.on-disable-import {
  background-color: #a6a6a6;
  cursor: not-allowed;
}

.file-input__label svg {
  height: 16px;
  margin-right: 4px;
}

.cursor-pointer {
  cursor: pointer;
}

.table-responsive {
  max-height: 380px;
  overflow-y: auto;
}

.table th {
  background-color: #f3f6f9;
  color: #464e5f;
  font-weight: 600;
  border-bottom: 2px solid #ebedf3;
}

.table td,
.table th {
  padding: 0.75rem;
  vertical-align: middle;
}
</style>
